export const emailCreateTemplateLink = `/emails/create-template`
export const emailTemplatesLink = `/emails/templates`
export const emailEditTemplateLink = `/emails/template/:id`
export const getEmailEditTemplateLink = (id) => `/emails/template/${id}`
export const emailSendEmailLink = `/emails/send-email`
export const emailSentEmailsLink = `/emails/sent-emails`